<button
	*mediaQuery="mediaQueryMax.Desktop"
	class="c-menu__toggle"
	type="button"
	[attr.aria-expanded]="isOpen()"
	(click)="handleMenuButtonClick()"
>
	Menu
</button>

<ng-container *mediaQuery="mediaQueryMin.Desktop" [ngTemplateOutlet]="primaryMenuTmpl"></ng-container>

<nav aria-label="Secondary navigation">
	<ul class="c-menu__items c-menu__items--grey-background">
		@for (item of secondaryMenuItems; track item) {
			<li class="c-menu__items__item">
				<a
					class="c-menu__items__item__link"
					cypressTag="Menu.Link"
					[routerLink]="item.routerLink"
					[routerLinkActive]="['is-active']"
					[routerLinkActiveOptions]="{ exact: !!item.exact }"
				>
					@if (itemTemplate) {
						<ng-template
							[ngTemplateOutlet]="itemTemplate"
							[ngTemplateOutletContext]="{ $implicit: item.id }"
						>
						</ng-template>
					} @else {
						{{ item.id }}
					}
				</a>
			</li>
		}
	</ul>
</nav>

<ng-template #primaryMenuTmpl>
	<nav aria-label="Primary navigation">
		<ul class="c-menu__items">
			@for (item of menuItems; track item) {
				<li class="c-menu__items__item">
					<a
						class="c-menu__items__item__link"
						cypressTag="Menu.Link"
						[routerLink]="item.routerLink"
						[routerLinkActive]="['is-active']"
						[routerLinkActiveOptions]="{ exact: !!item.exact }"
					>
						@if (itemTemplate) {
							<ng-template
								[ngTemplateOutlet]="itemTemplate"
								[ngTemplateOutletContext]="{ $implicit: item.id }"
							>
							</ng-template>
						} @else {
							{{ item.id }}
						}
					</a>
				</li>
			}
		</ul>
	</nav>
</ng-template>
